export default "__VITE_ASSET__7ff47d86__"